import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const slab = defineConnector({
  identifier: "slab",
  name: "Slab",
  tagLine: "Team knowledge base",
  logo,
  protocol: "http",
  tags: ["productivity", "documents"],
  defaultUrlPattern: () => "https://api\\.slab\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "authorization",
        value: app.secret.apiKey,
      },
    ]),
  steps: [
    {
      title: "Find your Slab API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Go to your Slab workspace settings → **Integrations → Developer** and generate an API token. You can also visit [slab.com/integrations](https://slab.com/integrations) directly.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content: "Enter the API credentials from your Slab account settings.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "Your Slab API token",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.slab.com/v1/graphql",
  },
});
